// extracted by mini-css-extract-plugin
export default {"listSectionHeader":"listSectionHeader---LX8hf","listSectionContent":"listSectionContent---OP8AG"};